/* eslint-disable arrow-parens */
import { useState, useCallback, useRef, useContext, useEffect, Suspense } from "react";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../contexts";
import { CustomDialog } from "../../../../shared";
import { CustomPagination } from "../../../../shared";
import getAgGridHeight from "../../../../../utils/commonFunctions/getAgGridHeight";
import { AgGridReact, AgGridColumn } from "ag-grid-react";

import { Button, IconButton, Tooltip } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import DescriptionIcon from "@material-ui/icons/Description";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { dateTimeZoneConverter } from "../../../../../utils/commonFunctions/date";
import { DependentChangeRequest, Member } from "../../../../../@types/member.types";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../utils/api";
import useRouteParam from "../../../../../hooks/useRouteParam";
import initCapitalize from "../../../../../utils/commonFunctions/initCapitalize";
import { useNavigate } from "react-router-dom";
import ExtractRouteParams from "../../../../../utils/commonFunctions/extractRouteParams";
import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import { downloadFileFromMongoDB } from "../../../../../utils/commonFunctions/downloadFileFromDatabase";

const DependentChangeRequestGrid = (): JSX.Element => {
	const [dependentChangeRequestDetails, setDependentChangeRequestDetails] = useState<DependentChangeRequest[]>([]);
	const [gridHeight, setGridHeight] = useState("400px");
	const queryGroupNumber = useRouteParam("gn");
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const navigate = useNavigate();

	const [pagination, setPagination] = useState({
		currentPage: 1,
		pageCount: 2
	});
	const [dependentChangeDialogProps, setDependentChangeDialogProps] = useState({
		openDialog: false,
		dialogName: "reject_dialog",
		title: "Do you want to accept the changes?",
		content: "To accept the changes click on Accept & Open Enrollment. If not, click on Reject",
		actions: [
			{
				label: "Reject",
				name: "reject",
				callback: () => {
					approveCreateDependentRequest(false);
					handleRejectDependentChangeRequest();
				}
			},
			{
				label: "Accept & Open Enrollment",
				name: "accept",
				callback: () => {
					approveCreateDependentRequest(true);
					handleAcceptDependentChangeRequest();
				}
			}
		]
	});
	const [dependentUpdationChangeDialogProps, setDependentUpdationChangeDialogProps] = useState({
		openDialog: false,
		dialogName: "reject_dialog",
		title: "Updation Alert!",
		content: "Do you want to change the Date of Birth from 24/09/1992 to 24/11/1992",
		actions: [
			{
				label: "Reject",
				name: "reject",
				callback: () => {
					setDependentUpdationChangeDialogProps(
						Object.assign({}, dependentUpdationChangeDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Accept ",
				name: "accept",
				callback: () => {
					setDependentUpdationChangeDialogProps(
						Object.assign({}, dependentUpdationChangeDialogProps, { openDialog: false })
					);
				}
			}
		]
	});
	const [dependentDeactivationDialogProps, setDependentDeactivationDialogProps] = useState({
		openDialog: false,
		title: "Do you want to Deactivate the dependent from member details?",
		content: "To deactivate the dependent click on Accept .If not, click on Reject",
		dialogName: "reject_dialog",
		actions: [
			{
				label: "Reject",
				name: "reject",
				callback: () => {
					setDependentDeactivationDialogProps(
						Object.assign({}, dependentDeactivationDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Accept",
				name: "accept",
				callback: () => {
					setDependentDeactivationDialogProps(
						Object.assign({}, dependentDeactivationDialogProps, { openDialog: false })
					);
				}
			}
		]
	});
	const { setDashboardHeader } = useContext(UIContext);

	const { currentPage, pageCount } = pagination;

	const handleAgGridReady = (params: any) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const getDependentChangeRequestInitData = useCallback(async () => {
		if (!queryGroupNumber) {
			return;
		}
		const response = await trackPromise(api.changeRequest.getCreateDependentRequest(queryGroupNumber as number));

		if (response) {
			const _dependentChangeDetails: DependentChangeRequest[] = [];

			response.forEach((dependent: DependentChangeRequest) => {
				_dependentChangeDetails.push({
					...dependent,
					request_for: "Addition"
				});
			});

			setDependentChangeRequestDetails(Object.assign([], _dependentChangeDetails));
		}
	}, [queryGroupNumber]);

	const approveCreateDependentRequest = useCallback(async (approveValue: boolean) => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { _id }
		} = row;

		// console.log("_id", _id);

		const approvePayload = {
			_id: _id,
			approval_status: approveValue
		};
		// console.log("Approve Payload", approvePayload);

		const response = await trackPromise(api.changeRequest.approveCreateDependentRequest(approvePayload));
		// console.log("Response", response);
	}, []);

	const handleRejectDependentChangeRequest = useCallback(() => {
		setDependentChangeDialogProps(Object.assign({}, dependentChangeDialogProps, { openDialog: false }));
		alert("Dependent request is rejected!");
		window.location.reload();
	}, [dependentChangeDialogProps]);

	const handleAcceptDependentChangeRequest = useCallback(() => {
		setDependentChangeDialogProps(Object.assign({}, dependentChangeDialogProps, { openDialog: false }));

		alert("Dependent is accepted successfully!");
		const pathname = `/employer/open-enrollment?${routeParam}`;
		navigate(pathname);
	}, [dependentChangeDialogProps, navigate, routeParam]);

	const handlePageChange = useCallback(
		(event: React.ChangeEvent<unknown>, page: number) => {
			setPagination(Object.assign({}, pagination, { currentPage: page }));
		},
		[pagination]
	);

	const handleOpenDependentChangeDialogClick = useCallback(() => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { request_for }
		} = row;

		// console.log("Open_id", _id);

		if (request_for === "Addition") {
			setDependentChangeDialogProps(Object.assign({}, dependentChangeDialogProps, { openDialog: true }));
		}
		// else if (request_for === "Updation") {
		// 	setDependentUpdationChangeDialogProps(
		// 		Object.assign({}, dependentUpdationChangeDialogProps, { openDialog: true })
		// 	);
		// } else if (request_for === "Deactivate") {
		// 	setDependentDeactivationDialogProps(
		// 		Object.assign({}, dependentDeactivationDialogProps, { openDialog: true })
		// 	);
		// }
	}, [dependentChangeDialogProps]);

	const handleDownloadEventDocumentClick = useCallback(() => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { event_document }
		} = row;

		downloadFileFromMongoDB(event_document);
	}, []);

	const handleCloseDependentChangeDialogClick = useCallback(() => {
		setDependentChangeDialogProps(Object.assign({}, dependentChangeDialogProps, { openDialog: false }));
	}, [dependentChangeDialogProps]);

	const handleCloseDependentUpdationChangeDialogClick = useCallback(() => {
		setDependentUpdationChangeDialogProps(
			Object.assign({}, dependentUpdationChangeDialogProps, { openDialog: false })
		);
	}, [dependentUpdationChangeDialogProps]);

	const handleCloseDependentDeactivationDialogClick = useCallback(() => {
		setDependentDeactivationDialogProps(Object.assign({}, dependentDeactivationDialogProps, { openDialog: false }));
	}, [dependentDeactivationDialogProps]);

	// const handleActionCellRender = useCallback(() => {
	// 	return (
	// 		<Button className="ag-grid-cell-button " variant="outlined" onClick={handleOpenDependentChangeDialogClick}>
	// 			Take Action
	// 		</Button>
	// 	);
	// }, [handleOpenDependentChangeDialogClick]);

	const handleActionCellRender = () => {
		return (
			<div>
				<Tooltip title="Download File" enterDelay={500} leaveDelay={200} arrow>
					<IconButton>
						<DescriptionIcon onClick={handleDownloadEventDocumentClick} />
					</IconButton>
				</Tooltip>
				<Tooltip title="Take Action" enterDelay={500} leaveDelay={200} arrow>
					<IconButton>
						<ExitToAppIcon onClick={handleOpenDependentChangeDialogClick} />
					</IconButton>
				</Tooltip>
			</div>
		);
	};

	const handleDateCellRenderer = ({ value }: { value: string }) => dateTimeZoneConverter(value);

	const handleCapitalizeCellRenderer = ({ value }: { value: string }) => {
		const capitalize = initCapitalize(value);
		return <div>{capitalize}</div>;
	};

	const handleUpdateNameCellRenderer = ({ value }: { value: any }) => {
		// console.log("Value ", value);
		const nameUpdate =
			value?.first_name + " " + (value?.middle_name ? value?.middle_name : "") + " " + value?.last_name;
		return <div>{nameUpdate}</div>;
	};

	const handleRequestCellRenderer = ({ value }: { value: any }) => {
		return <div>Addition</div>;
	};

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dependent_change_request);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (queryGroupNumber) getDependentChangeRequestInitData();
	}, [getDependentChangeRequestInitData, queryGroupNumber]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(dependentChangeRequestDetails.length);
		setGridHeight(_gridHeight);
	}, [dependentChangeRequestDetails.length]);

	return (
		<>
			<Suspense fallback={<div />}>
				<CustomDialog
					dialogProps={dependentChangeDialogProps}
					handleClose={handleCloseDependentChangeDialogClick}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<CustomDialog
					dialogProps={dependentUpdationChangeDialogProps}
					handleClose={handleCloseDependentUpdationChangeDialogClick}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<CustomDialog
					dialogProps={dependentDeactivationDialogProps}
					handleClose={handleCloseDependentDeactivationDialogClick}
				/>
			</Suspense>
			<div
				className="dependent-change-request-grid-container glb-tab-grid-container"
				id="dependent-change-request-grid-container"
			>
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={dependentChangeRequestDetails}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						suppressColumnVirtualisation={true}
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true,
							floatingFilterComponentParams: { suppressFilterButton: true }
						}}
						frameworkComponents={{
							handleCapitalizeCellRenderer: handleCapitalizeCellRenderer,
							handleActionCellRender: handleActionCellRender,
							handleUpdateNameCellRenderer: handleUpdateNameCellRenderer,
							handleDateCellRenderer: handleDateCellRenderer,
							handleRequestCellRenderer: handleRequestCellRenderer
						}}
					>
						<AgGridColumn
							field="employee.member_id"
							headerName="Employee Id"
							suppressSizeToFit={true}
						></AgGridColumn>
						<AgGridColumn
							field="employee"
							headerName="Employee Name"
							cellRenderer="handleUpdateNameCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="created_date"
							headerName="Request Date"
							cellRenderer="handleDateCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="request_for"
							headerName="Request For"
							cellRenderer="handleRequestCellRenderer"
							suppressSizeToFit={true}
						></AgGridColumn>
						<AgGridColumn
							field="first_name"
							headerName="Dependent First Name"
							// cellRenderer="handleUpdateNameCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="last_name"
							headerName="Dependent Last Name"
							// cellRenderer="handleUpdateNameCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="relationship"
							headerName="Relationship"
							cellRenderer="handleCapitalizeCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="event_name"
							headerName="Qualifying Event"
							suppressSizeToFit={true}
							cellRenderer="handleCapitalizeCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleActionCellRender"
							filter={false}
							suppressSizeToFit={true}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
			{/* <div className="custom-pagination" id="custom-pagination">
				<CustomPagination pageCount={pageCount} currentPage={currentPage} handlePageChange={handlePageChange} />
			</div> */}
		</>
	);
};

export default DependentChangeRequestGrid;
